import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../baseurl";
import { useNavigate } from "react-router-dom";
import Header from "../component/Header";

function VendorAuth() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    businessName: "",
    gstNumber: "",
    website: "",
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    // ✅ Log the data being sent
    console.log("Sending vendor registration data:", formData);

    const res = await axios.post(`${baseurl}vendorRegistration`, formData);

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: "Registration successful! Our team will contact you shortly.",
      showConfirmButton: false,
      timer: 2500,
      background: "#28a745",
      color: "#fff",
    });

    setFormData({
      name: "",
      email: "",
      phone: "",
      businessName: "",
      gstNumber: "",
      website: "",
    });
  } catch (err) {
    console.error("Error response:", err.response); // Optional: log full error
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "error",
      title: err.response?.data?.error || "Something went wrong",
      showConfirmButton: false,
      timer: 2500,
      background: "#e74c3c",
      color: "#fff",
    });
  } finally {
    setLoading(false);
  }
};


  return (
   <>
   <Header/>
      <div className="container   p-4">
        <div className="row align-items-center g-5">
          {/* Left: Info Section */}
          <div className="col-lg-6">
            <h1 className="fw-bold mb-3 text-dark">Start Selling on SubCity</h1>
            <p className="text-muted lead">
              Join India’s fastest-growing eCommerce marketplace. Showcase your
              products to millions of customers and grow your business effortlessly!
            </p>

            <h5 className="mt-4 fw-bold">🌟 Why Sell With Us?</h5>
            <ul className="list-unstyled text-muted">
              <li>✅ Reach millions of customers nationwide</li>
              <li>✅ Simple registration and verification</li>
              <li>✅ Seller dashboard with analytics tools</li>
              <li>✅ Fast & secure payments</li>
              <li>✅ Dedicated support for your growth</li>
            </ul>

            <h5 className="mt-4 fw-bold">📈 How It Works</h5>
            <ol className="text-muted">
              <li>Register with your business details</li>
              <li>Verify your account</li>
              <li>Start listing and selling products</li>
              <li>Track sales, inventory, and earnings</li>
            </ol>
          </div>

          {/* Right: Form Section */}
          <div className="col-lg-6">
            <div className="card border-0 shadow p-4 rounded-4">
              <h3 className="text-center fw-bold mb-3 text-primary">
                Vendor Registration
              </h3>
              <p className="text-center text-muted mb-4">
                Fill in your details and we’ll help you get started.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Full Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your full name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    className="form-control"
                    placeholder="+91 9876543210"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Business Name</label>
                  <input
                    type="text"
                    name="businessName"
                    className="form-control"
                    placeholder="Your store/business name"
                    value={formData.businessName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">GST Number (if any)</label>
                  <input
                    type="text"
                    name="gstNumber"
                    className="form-control"
                    placeholder="GST number"
                    value={formData.gstNumber}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Website / Store Link (optional)
                  </label>
                  <input
                    type="text"
                    name="website"
                    className="form-control"
                    placeholder="https://yourstore.com"
                    value={formData.website}
                    onChange={handleChange}
                  />
                </div>

                <div className="text-center mt-4">
                 <button
  type="submit"
  className="btn btn-primary btn-lg w-100 d-flex justify-content-center align-items-center"
  disabled={loading}
>
  {loading && (
    <span
      className="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true"
    ></span>
  )}
  {loading ? "Submitting..." : "Submit Application"}
</button>
                </div>
              </form>

              <div className="mt-4 text-center text-muted small">
                By submitting, you agree to our{" "}
                <a href="#" className="text-decoration-none">
                  Terms & Conditions
                </a>{" "}
                and{" "}
                <a href="#" className="text-decoration-none">
                  Privacy Policy
                </a>.
              </div>
            </div>
          </div>
        </div>
 
      </div>
     </>
  );
}

export default VendorAuth;
